import { Api } from '../api';
import { ICreateEnvio, IDetalheEnvio, IResponseEnvio, IResponseLogEnvio } from 'shared/types';





const getById = async (id: number, idcanal :number): Promise<IDetalheEnvio | Error> => {
  try {
    const { data } = await Api.get(`${id}/ConfEnvio/${idcanal}`);
    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const getAll = async (idOrg: number,filter = ''): Promise<IResponseEnvio | Error> => {
  try{
    const { data, status } = await Api.get(`/${idOrg}/ConfEnvio/${filter !== '' ? '?' : ''}${filter}`);

    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const create = async (dados: ICreateEnvio): Promise<string | Error> => {
  try {
    const { data, status } = await Api.post(`/ConfEnvio?cod_org=${dados.OrgCodigo}&cod_canal=${dados.CanalId}&dhUsuUpdIni=${dados.DhEnvioIni}&dhUsuUpdFin=${dados.DhEnvioFin}`);
    

    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        if('errors' in data){
          const chaves = Object.keys(data.errors); // Acessar a primeira chave const primeiraPropriedade = chaves[0];
          return new Error(data.errors[chaves[0]][0]);
        }else{
          return new Error(`${data.retorno} `);    
        }
      }
      return data.codigoOrganizacao;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const update = async ( dados:ICreateEnvio): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/ConfEnvio?cod_org=${dados.OrgCodigo}&cod_canal=${dados.CanalId}&dhUsuUpdIni=${dados.DhEnvioIni?.substring(0, 23)}&dhUsuUpdFin=${dados.DhEnvioFin?.substring(0, 23)}`);
                               
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data.retorno);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};


const deleteById = async (id: string): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const getAllLogs = async (idOrg:number,filter = ''): Promise<IResponseLogEnvio | Error> => {
  try{
    const { data, status } = await Api.get(`/${idOrg}/ConfEnvioLog/${filter !== '' ? '?' : ''}${filter}`);

    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const EnvioService = {

  getById,
  getAll,
  create,
  update,
  deleteById,
  getAllLogs
};
